import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormArray, UntypedFormBuilder, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { CustomValidators } from 'ngx-custom-validators';
import { CustomValidators as CustomLocalValidators } from "../../../../core/custom-validator/custom-validators";
// import { VirtualTerminalListViewComponent } from '../virtual-terminal-list-view/virtual-terminal-list-view.component';
import { CommonService } from 'src/app/providers/common.service';
import { ZipConfigService } from 'src/app/core/services/zip-config.service';
import {apiLinks} from "../../../../core/api-links/api-links";
import { NgbModal, NgbModalOptions, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { AuthService } from '../../../../providers/auth.service';
import * as moment from 'moment';
import {get, padStart,random, isEmpty} from 'lodash';
import { BehaviorSubject, Observable, Subscription, of } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { PaymentStatusComponent } from '../payment-status/payment-status.component';


@Component({
  selector: 'app-paya-ach',
  templateUrl: './paya-ach.component.html',
  styleUrls: ['./paya-ach.component.scss'],
  // encapsulation:ViewEncapsulation.,
})
export class PayaAchComponent implements OnInit, OnChanges {
  public eventsSubscription: Subscription;

  @Input() selectedMode:any;
  @Input() transactionType:any;
  @Input() parentCloudposForm: any;
  @Input() payaTransaction$: Observable<any>;
  @Input() selectedTpn:any;
  @Input() ppdOrCcdOptions:any;
  @Input() selectedPayaOption:any;
  @Input() ppdOrCcdOptionsArray:any;
  @Input() defautTerminalType:any;
  @Input() steamTagsForm:any;
  @Input() isEnableTag:any;
  @Input() events: Observable<any>;
  @Input() fortInvoice: any;
  @Input() isFortellisEnabled: any;
  @Input() isAddBank: Boolean = false;
  @Input() consumerId: any;
  @Input() tagValues: any = {}; 
  private subscription: Subscription;
   
 
  @Output() payaAchFormData =  new EventEmitter<any>();
  @Output() notifyParentReset: EventEmitter<any> = new EventEmitter();
  @Output() phoneErrorHandler: EventEmitter<any> = new EventEmitter();
  @Output() getConsumerDetail: EventEmitter<any> = new EventEmitter();
  @Output() getExstingCustomerPayload: EventEmitter<any> = new EventEmitter();
  @Output() clearUnMaskedAlternateCard: EventEmitter<any> = new EventEmitter();
  @Output() verifyExstingCard: EventEmitter<any> = new EventEmitter();
  @Output() isPayaCheck: EventEmitter<any> = new EventEmitter();
  @Output() isAlternateTokenCheckPayaCheck: EventEmitter<any> = new EventEmitter();
  @Output() terminalTypeSelection: EventEmitter<any> = new EventEmitter();
  @Output() isDisableReset = new EventEmitter<boolean>();
  @Input() payaResponseValidation$: Observable<any>;
  @Input() payaRest$: Observable<any>;
  @Output() addBankConfirmation: EventEmitter<any> = new EventEmitter();
  @Input() isMandatoryCheck : boolean;


  buttonValue: any = "0";

  dynamicValidationJson : any = {};

  modalRef:any;

  private resetFormAmt = new BehaviorSubject<any>({});
  resetFormAmtVal$ = this.resetFormAmt.asObservable();

  private ssnSubscription: Subscription;
  private birthYearSubscription: Subscription;
  private formResetSubscription: Subscription;


  constructor(
    private formBuilder: UntypedFormBuilder,
    public commonService: CommonService,
    private ngbModal: NgbModal,
    private authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private zipConfigService: ZipConfigService
  ) { }

  cloudPOSForms: UntypedFormGroup;
 
  fieldRequired:any;
  fieldRequiredState:any;
  fieldRequiredName:any;
  fieldRequiredFirstName:any;
  fieldRequiredCheckNumber:any;
  fieldRequiredNameaddr1:any;
  fieldRequiredNameaddr2:any;
  fieldCourtesyCardId:any;
  isCourtesyCardRequired:boolean;
  isCompanyNameRequired:boolean;
  isTelSecCode:boolean
  dlnumberValidators:any;
  isCityRequired: any;
  isStateRequired: any;
  isZipRequired: any;
  isPhoneRequired:any;
  terminalId:any;
  amount:any;
  number:any;
  email:any;
  accountTypeList = [{name:"Checking",id:"Checking"},{name:"Savings", id:"Savings"}];
  submitted = false;
  isIdentityRequired:boolean;
  usersID:any;
  payaStates = [];
  birthYearValidators:any;
  ssnValidators:any;
  checkNumberField:string;
  entryClass:any;
  isTokenTx:boolean = false;
  isfromRunASale:boolean = false;
  payaId:any;
  cardsLength:any;
  isMaskedCard:boolean=false;
  payaResponseValidationSubscription:Subscription;

  previousTransaction;
  perviousPpdOrCcdOptionsArray; 
  maskedRoutingFormat = "000000000";
  maskedAccountFormat = "00000000000000000";
  customValue:any;
  public isAchAdded: string = '';
  public isAddAch: boolean = this.activatedRoute.snapshot.params.path == 'add-ach';
  public params: any = {
    ...(this.activatedRoute.snapshot.params || {}),
    ...(this.activatedRoute.snapshot.queryParams || {})
  };
  fieldVisibility: Record<string, boolean> = {};
  showVerificationSection = false;

  get zipCtrl(): AbstractControl | null {
    return this.cloudPOSForms?.get('zipCode') ?? null;
  }

  get zipMaxLength(): number {
    return this.zipConfigService.getMaxLength();
  }

  hasZipValidationError(): boolean {
    return !!(this.zipCtrl?.errors?.['invalidZip'] || this.zipCtrl?.errors?.['invalidChars']);
  }

  showZipError(): boolean {
    return !!(this.zipCtrl?.dirty || this.zipCtrl?.touched || this.submitted);
  }

  ssnOrBirthYearRequired(control: AbstractControl): ValidationErrors | null {
    const ssnValue = control.get('ssn').value;
    const birthYearValue = control.get('birthYear').value;
    let status = control.get('identity').value;
    if (!ssnValue && !birthYearValue && status) {
      return { ssnOrBirthYearRequired: true };
    }
  
    if (ssnValue && (ssnValue.length > 4 || !/^\d{4}$/.test(ssnValue))) {
      // SSN should be a maximum of 4 digits
      return { ssnFormatInvalid: true };
    }
  
    if (birthYearValue) {
      if (birthYearValue.length !== 4 || !/^(19|20)\d{2}$/.test(birthYearValue)) {
        // Birth Year should be 4 digits and start with 19 or 20
        return { birthYearFormatInvalid: true };
      }
    }
    return null;
  }
  isResetDisabled: boolean = false;
  secCode;
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isMandatoryCheck'] && this.dynamicValidationJson) {
      this.updateFieldVisibility();
    }
  }

  ngOnInit(): void {
     
    // console.log(`payaresponse test_______________`,this.payaResponseValues);

    // this.isPayaCheck.emit({isPaya:true})
    this.perviousPpdOrCcdOptionsArray = this.ppdOrCcdOptionsArray;
    this.isTelSecCode = this.selectedPayaOption == 1;
    console.log('...isTelSecCode...', this.isTelSecCode);
    this.payaResponseValidationSubscription = this.payaResponseValidation$?.subscribe(res => {
      console.log('...res.secCode...');
      if (res.defautTerminalType) {
        this.defautTerminalType = res.defautTerminalType;
      }
      this.secCode = this.defautTerminalType;
      // this.previousTransaction  = this.cloudPOSForms;
      this.terminalId = res.terminalId;
      this.usersID = res.validationID;
      this.dynamicValidationJson = res.validation;      
      this.createPayaAchForm();
      if (this.isEnableTag == 1) {
        this.steamTagsForm.valueChanges.subscribe((val) => {
          this.customValue = val;
          this.setCustomTag();
        });
      } 
      // this.refillForm()
    })
    this.getPayaStates();
    // this.identityValidator();
   this.subscription =  this.payaTransaction$?.subscribe((res) => {     
      if (!res) {
        return
      }
      if(res.isfromExstingPayload){
        this.matchOldAndNewPayload( res, this.cloudPOSForms.value);
      }else{
        if(res.terminalId){
          this.previousTransaction = res;
        }
        this.maskedRoutingFormat = "";
        this.maskedAccountFormat = "";
        if (res.isFromTransaction == true) {
           if(this.previousTransaction?.value){
             if(this.secCode){
               this.previousTransaction.value.terminalType = this.secCode;
               this.previousTransaction.value.entryClass = this.secCode;
             }
             this.cloudPOSForms.patchValue(this.previousTransaction.value);
           }
          this.getTerminalTypeValueChanges(this.cloudPOSForms.get('terminalType'));  
          this.onTransaction();
        }
        this.isDisableReset.subscribe((state: boolean) => {
          this.isResetDisabled = state;
        });
          // if reset trigger from cloud pos
          if (res === 'resetFields' && this.isTokenTx ) {
            this.isTokenTx = false;
            this.payaId = null;
            this.cardsLength = 0;
            this.isMaskedCard = false;
            this.maskedRoutingFormat = "";
            this.maskedAccountFormat = "";
            this.onReset();
          }
        // if tokenized trigger from cloud pos
        if(res.isFromTokenized == true){
          this.isfromRunASale = res.isfromRunASale;
          this.isTokenTx = true;
          this.payaId = res.payaId;
          this.cardsLength = res.cardsLength;
          this.isMaskedCard = res.isMaskedCard;
          this.isTelSecCode = res.selectedPayaOption == 1;
          this.terminalId = res.tokenObj?.terminalId;
          this.usersID = res.tokenObj?.validationID;
          this.dynamicValidationJson = res.tokenObj?.validation;
          this.defautTerminalType = res.tokenObj?.defautTerminalType;
          if(this.perviousPpdOrCcdOptionsArray && this.perviousPpdOrCcdOptionsArray.length > 0){
            this.ppdOrCcdOptionsArray = this.perviousPpdOrCcdOptionsArray;
          }
          this.createPayaAchForm(true);
          this.cloudPOSForms.patchValue({
            routingNumber: res.routingNumber,
            accountNumber: res.accountNumber,
            accountType: res.accountType,
            firstName: res.firstName,
            lastName: res.lastName,
            city: res.city,
            zipCode: res.zipCode,
            addressOne: res.addressOne,
            addressTwo: res.addressTwo,
            phone: res.phone,
            dlNumber: res.dlNumber,
            companyName: res.companyName,
            ssn: res.ssn,
            birthYear: res.birthYear,
            courtesyCardId: res.courtesyCardId
          });
          if (res.dlState != 'null' && res.dlState != null && res.dlState) {
            this.cloudPOSForms.patchValue({
              dlState: res.dlState,
            });
          }
          if (res.state && res.state != 'null' && res.state != null) {
            this.cloudPOSForms.patchValue({
              state: res.state,
            });
          }

          let routingNumControllerTx = this.cloudPOSForms.get('routingNumber');
          let accountNumControllerTx = this.cloudPOSForms.get('accountNumber');
          routingNumControllerTx.setValidators([Validators.required, Validators.minLength(9), Validators.pattern(/^[0-9*]+$/)]);
          accountNumControllerTx.setValidators([Validators.required, Validators.minLength(4), Validators.maxLength(17)]);
          accountNumControllerTx.updateValueAndValidity();
          routingNumControllerTx.updateValueAndValidity();
          if(res.isfromRunASale){
            this.isAlternateTokenCheckPayaCheck.emit({'isAlternate': false});
          }else{
            this.isAlternateTokenCheckPayaCheck.emit({'isAlternate': true});
          }
        }
        if(res.isHsmDown === true){
          this.terminalId = res.tokenObj?.terminalId;
          this.usersID = res.tokenObj?.validationID;
          this.dynamicValidationJson = res.tokenObj?.validation;
          this.isfromRunASale = res.isfromRunASale;
          this.defautTerminalType = res.tokenObj?.defautTerminalType;
          if(this.perviousPpdOrCcdOptionsArray && this.perviousPpdOrCcdOptionsArray.length > 0){
            this.ppdOrCcdOptionsArray = this.perviousPpdOrCcdOptionsArray;
          }
          this.isTelSecCode = res.selectedPayaOption == 1;
          this.createPayaAchForm(true) 
          this.cloudPOSForms.patchValue({
            routingNumber: res.routingNumber,
            accountNumber: res.accountNumber,
            accountType: res.accountType,
            firstName: res.firstName,
            lastName: res.lastName,
            city: res.city,
            zipCode: res.zipCode,
            addressOne: res.addressOne,
            addressTwo: res.addressTwo,
            phone: res.phone,
            dlNumber: res.dlNumber,
            companyName: res.companyName,
            ssn: res.ssn,
            birthYear: res.birthYear,
            courtesyCardId: res.courtesyCardId
          });
          if (res.dlState != 'null' && res.dlState != null && res.dlState) {
            this.cloudPOSForms.patchValue({
              dlState: res.dlState,
            });
          }
          if (res.state != 'null' && res.state != null && res.state) {
            this.cloudPOSForms.patchValue({
              state: res.state,
            });
          }
          let routingNumControllerTx = this.cloudPOSForms.get('routingNumber');
          let accountNumControllerTx = this.cloudPOSForms.get('accountNumber');
          routingNumControllerTx.setValidators([Validators.required, Validators.minLength(9), Validators.pattern(/^[0-9*]+$/)]);
          accountNumControllerTx.setValidators([Validators.required, Validators.minLength(4), Validators.maxLength(17)]);
          accountNumControllerTx.updateValueAndValidity();
          routingNumControllerTx.updateValueAndValidity();
          if(res.isfromRunASale){
            this.isAlternateTokenCheckPayaCheck.emit({'isAlternate': false});
          }else{
            this.isAlternateTokenCheckPayaCheck.emit({'isAlternate': true});
          }
        }
        // if reset trigger from cloud pos
        if (res === 'reset') {
          this.isTokenTx = false;
          this.payaId = null;
          this.cardsLength = 0;
          this.isMaskedCard = false;
          this.maskedRoutingFormat = "";
          this.maskedAccountFormat = "";
          this.onReset();
        }
      }
    });

    this.formResetSubscription = this.payaRest$?.subscribe((res) => {
      if (res === true) {
        this.onReset();
      }
    });

     if (this.isPhoneRequired) {
       this.isPayaCheck.emit({ isPaya: true });
     } else {
       this.isPayaCheck.emit({ isPaya: false });
     }
     if (this.events) {
      this.eventsSubscription = this.events.subscribe((value) => {
        this.fortInvoice = value.fortInvoice;
        this.isFortellisEnabled = value.isFortellisEnabled;
      });
    }

  }
  updatedPayload;
  async matchOldAndNewPayload(oldPayload,currentPayload){
    this.updatedPayload = {};
    const considerFields = [
      'firstName', 'lastName', 'addressOne', 'addressTwo', 'city', 'state', 
      'zipCode', 'phone', 'dlState', 'dlNumber', 'companyName', 'ssn', 
      'birthYear', 'courtesyCardId'
    ];
    await this.updateMissingFields(oldPayload,currentPayload,considerFields);
    this.updatedPayload = currentPayload;
    this.onTransaction(true);
  }

  isExstingPayloadUpdate:boolean = false;
  updateMissingFields = (oldPayload, currentPayload, fieldsToConsider) => {
    this.isExstingPayloadUpdate = false;
    fieldsToConsider.forEach(field => {
        // Check if the field is missing or empty in the new payload
        if (!currentPayload.hasOwnProperty(field) && (oldPayload[field] != "" && oldPayload.hasOwnProperty(field))) {
          // If missing, update from the old payload
          this.isExstingPayloadUpdate = true;
          currentPayload[field] = oldPayload[field];
        }
        const valueChanged = oldPayload.hasOwnProperty(field) 
        && currentPayload.hasOwnProperty(field) && 
        oldPayload[field] != currentPayload[field];
        const currentVlaueUpdated = currentPayload.hasOwnProperty(field) && !oldPayload.hasOwnProperty(field);
         if(valueChanged || currentVlaueUpdated){
          this.isExstingPayloadUpdate = true;
        }
    });
  };
  
  setCustomTag(){
    Object.keys(this.customValue).forEach((key, index) => {
      const controlName = `custom${index + 1}`; 
      let value = this.customValue[key] || '';       
      this.cloudPOSForms.get(controlName)?.patchValue(value);
    });  
  }

  updateFieldVisibility() {
    if (!this.dynamicValidationJson) return;

    this.fieldVisibility = {};

    Object.keys(this.dynamicValidationJson).forEach(key => {
      const field = this.dynamicValidationJson[key];

      if (!field) {
        this.fieldVisibility[key] = false;
      } else if (this.isMandatoryCheck) {
        this.fieldVisibility[key] = !!field.required;
      } else {
        this.fieldVisibility[key] = true;
      }
        this.updateVerificationDividerVisibility();
    });
  }

  updateVerificationDividerVisibility() {
    const f = this.fieldVisibility;
    const idRequired = this.dynamicValidationJson?.IDENTITY?.required;
    this.showVerificationSection = !!(
      f?.DL_NUMBER ||
      f?.DL_STATE ||
      idRequired
    );
  }



  createPayaAchForm(isFromToken = false) {
    this.isCourtesyCardRequired = get(this.dynamicValidationJson,'COURTESY_CARD_ID.required', false);
    this.isCompanyNameRequired = get(this.dynamicValidationJson,'COMPANY_NAME.required', false);
    console.log('....this.isCompanyNameRequired....', this.isCompanyNameRequired);
    // let nameValidators =  [Validators.required, Validators.pattern(/^[a-zA-Z ]+$/),Validators.minLength(1),Validators.maxLength(100)];
    let firstnameValidators = [Validators.pattern(/^[a-zA-Z ]+$/), Validators.minLength(1), Validators.maxLength(100)];
    let lastNameValidators = [Validators.pattern(/^[a-zA-Z ]+$/), Validators.minLength(1), Validators.maxLength(100)];
    let routingValidators = [Validators.required,Validators.minLength(9),Validators.pattern(/^[0-9]+$/)];
    let accountValidators = [Validators.pattern(/^[0-9]+$/), Validators.minLength(4), Validators.maxLength(17)];
    let checkNumberValidators = [Validators.pattern(/^[0-9]+$/), Validators.minLength(1), Validators.maxLength(15)];
    let zipCodeValidators = [...this.zipConfigService.getZipValidators()];
    let dlnumberValidators = [Validators.pattern(/^[a-zA-Z0-9]+$/), Validators.minLength(1), Validators.maxLength(50)]
    this.ssnValidators = [Validators.required,Validators.pattern(/^[0-9]+$/),Validators.minLength(1),Validators.maxLength(4)];
    let dlStateValidators = [Validators.pattern(/^[a-zA-Z]{2,15}$/), Validators.minLength(1), Validators.maxLength(15)];
    let stateValidators = [Validators.pattern(/^[a-zA-Z]{2,15}$/), Validators.minLength(1), Validators.maxLength(15)];
    this.birthYearValidators = [Validators.required,Validators.pattern(/^(19|20)\d*$/),Validators.minLength(4),Validators.maxLength(4)];
    let addressValidators = [Validators.pattern(/^[a-zA-Z0-9 ,.\-/#]+$/), Validators.maxLength(200)];
    let addressValidatorsTwo = [Validators.pattern(/^[a-zA-Z0-9 ,.\-/#]+$/), Validators.maxLength(200)];
    let cityValidators = [Validators.pattern(/^[a-zA-Z ]+$/), Validators.minLength(1), Validators.maxLength(50)]
    let courtesyCardIdValidator = this.isCourtesyCardRequired ? [Validators.required,Validators.pattern(/^[a-zA-Z0-9]+$/),Validators.minLength(1),Validators.maxLength(50)]: [];
    
    if (this.dynamicValidationJson?.FIRST_NAME?.required) firstnameValidators.push(Validators.required)
    if (this.dynamicValidationJson?.LAST_NAME?.required) lastNameValidators.push(Validators.required)
    if (this.dynamicValidationJson?.ACCOUNT?.required) accountValidators.push(Validators.required)
    if (this.dynamicValidationJson?.ZIP?.required) zipCodeValidators.push(Validators.required)
    if (this.dynamicValidationJson?.CITY?.required) cityValidators.push(Validators.required)
    if (this.dynamicValidationJson?.STATE?.required) stateValidators.push(Validators.required)
    if (this.dynamicValidationJson?.CHECK?.required) checkNumberValidators.push(Validators.required)
    if (this.dynamicValidationJson?.ADDRESS1?.required) addressValidators.push(Validators.required)
    if (this.dynamicValidationJson?.ADDRESS2?.required) addressValidatorsTwo.push(Validators.required)
    if (this.dynamicValidationJson?.DL_NUMBER?.required) dlnumberValidators.push(Validators.required)
    if (this.dynamicValidationJson?.DL_STATE?.required) dlStateValidators.push(Validators.required)

     if (!this.isTelSecCode || isFromToken) {
      const index = checkNumberValidators.indexOf(Validators.required);
      if (index !== -1) {
        checkNumberValidators.splice(index, 1);
      }
    }
    let firstNameLastNameFormControl = {firstName: [
      "",
      this.dynamicValidationJson?.FIRST_NAME?.required
        ? firstnameValidators
        : [],
    ],
    lastName: [
      "",
      this.dynamicValidationJson?.LAST_NAME?.required
        ? lastNameValidators
        : [],
    ]};
    let companyNameFormControl = {companyName: [
      "",
      this.dynamicValidationJson?.COMPANY_NAME?.required
        ? [Validators.required, ...firstnameValidators]
        : [],
    ]}
    let paymentMode = null;

    if (this.isAddBank) {
      const paymentInfo = this.parentCloudposForm.controls.paymentInfo;
      paymentMode = paymentInfo?.controls?.paymentMode?.value;
    }

    this.cloudPOSForms = this.formBuilder.group({
      amt: [""],
      usersId: [this.usersID],
      terminalId: [this.terminalId],
      tpn: [this.selectedTpn],
      email: [""],
      phone: [""],
      paymentMode: [this.isAddBank ? paymentMode : this.selectedMode.name],
      transactionType: this.selectedMode.id,
      ...(!this.isCompanyNameRequired ? firstNameLastNameFormControl : companyNameFormControl),
      accountType: ["Checking", [Validators.required]],
      ...(!this.isTelSecCode ? { terminalType: [this.defautTerminalType, [Validators.required]] } : {}),
      routingNumber: ["", routingValidators],
      accountNumber: ["", accountValidators],
      checkNumber: ["", checkNumberValidators],
      entryClass: [this.isTelSecCode ? "TEL" : this.defautTerminalType, [Validators.required]],
      zipCode: ["", zipCodeValidators],
      city: ["", cityValidators],
      state: [null, stateValidators],
      addressOne: ["", addressValidators],
      addressTwo: ["", addressValidatorsTwo],
      dlNumber: ["", dlnumberValidators],
      dlState: [null, dlStateValidators],
      ssn: [""],
      birthYear: [""],
      courtesyCardId: ["", courtesyCardIdValidator],
      identity: get(this.dynamicValidationJson, 'IDENTITY.required', false)
    }, { validators: this.ssnOrBirthYearRequired });

    for (let index = 1; index <= 3; index++) {
      this.cloudPOSForms.addControl(`custom${index}`, this.formBuilder.control('', []));
    }

    if (this.isPhoneRequired) {
      this.phoneErrorHandler.emit();

    }
    this.setRequiredFieldsStars();
    this.updateFieldVisibility();
    if(!this.isTokenRemoved){
      if(this.isTokenTx){
        this.setTokinizedData();  
      }
      if(!this.isTokenTx){
        if(this.previousTransaction?.value){
          if(this.secCode){
            this.previousTransaction.value.terminalType = this.secCode;
            this.previousTransaction.value.entryClass = this.secCode;
          }
          this.cloudPOSForms.patchValue(this.previousTransaction.value);
        }
      }
    }
    this.getTerminalTypeValueChanges(this.cloudPOSForms.get('terminalType'));  
    this.isTokenRemoved = false; 
  }

  setTokinizedData(){
    if(this.previousTransaction){
      if (this.previousTransaction?.value) {
        if(this.secCode){
          this.previousTransaction.value.terminalType = this.secCode;
          this.previousTransaction.value.entryClass =  this.secCode;
        }
        this.previousTransaction.value.entryClass = this.isTelSecCode ? "TEL" :this.previousTransaction.value.terminalType;
        this.cloudPOSForms.patchValue(this.previousTransaction.value);
      } else {
        this.cloudPOSForms.patchValue({
          routingNumber: this.previousTransaction.routingNumber,
          accountNumber: this.previousTransaction.accountNumber,
          accountType: this.previousTransaction.accountType,
          firstName: this.previousTransaction.firstName,
          lastName: this.previousTransaction.lastName,
          city: this.previousTransaction.city,
          zipCode: this.previousTransaction.zipCode,
          addressOne: this.previousTransaction.addressOne,
          addressTwo: this.previousTransaction.addressTwo,
          phone: this.previousTransaction.phone,
          dlNumber: this.previousTransaction.dlNumber,
          companyName: this.previousTransaction.companyName,
          ssn: this.previousTransaction.ssn,
          birthYear: this.previousTransaction.birthYear,
          courtesyCardId: this.previousTransaction.courtesyCardId
        });
        if (this.previousTransaction.dlState != 'null' && this.previousTransaction.dlState != null && this.previousTransaction.dlState) {
          this.cloudPOSForms.patchValue({
            dlState: this.previousTransaction.dlState,
          });
        }
        if (this.previousTransaction.state != 'null' && this.previousTransaction.state != null && this.previousTransaction.state) {
          this.cloudPOSForms.patchValue({
            state: this.previousTransaction.state,
          });
        }
      }
    }
  }

  isControlRequired(controlName: string): boolean {
    const control = this.cloudPOSForms.get(controlName);
    if (control) {
      const validators = control.validator && control.validator({} as AbstractControl);
      return validators ? validators.required : false;
    }
    return false;
  }
  
  getTerminalTypeValueChanges(terminalTypeFormControl) {
    if(terminalTypeFormControl) {
      this.cloudPOSForms.get('terminalType').valueChanges.subscribe(data => {
        this.defautTerminalType = data;
        this.terminalTypeSelection.emit({selectedData:data});
        this.isPayaCheck.emit({ isPaya: this.isPhoneRequired });
      });
      if(this.isTokenTx){
        let routingNumControllerTx = this.cloudPOSForms.get('routingNumber');
        let accountNumControllerTx = this.cloudPOSForms.get('accountNumber');
        routingNumControllerTx.setValidators([Validators.required, Validators.minLength(9), Validators.pattern(/^[0-9*]+$/)]);
        accountNumControllerTx.setValidators([ Validators.minLength(4), Validators.maxLength(17)]);
        accountNumControllerTx.updateValueAndValidity();
        routingNumControllerTx.updateValueAndValidity();
      }
    }
  }
  setRequiredFieldsStars() {
    console.log('..........COURTESY_CARD_ID.............', this.dynamicValidationJson);
    this.fieldRequired = this.dynamicValidationJson?.DL_NUMBER?.required
      ? "*"
      : "";
   
    this.fieldRequiredState = this.dynamicValidationJson?.DL_STATE?.required
      ? "Select a DL State*"
      : "Select a DL State";
   
      this.fieldRequiredName  = (this.dynamicValidationJson?.LAST_NAME?.required || this.dynamicValidationJson?.COMPANY_NAME?.required) 
      ? "*"
      : "";
      this.fieldRequiredFirstName = this.dynamicValidationJson?.FIRST_NAME?.required
      ? "*"
      : "";
      this.fieldRequiredCheckNumber = this.isTelSecCode
      ? "*"
      : "";
      this.fieldRequiredNameaddr1  = this.dynamicValidationJson?.ADDRESS1?.required
      ? "*"
      : "";
      this.fieldRequiredNameaddr2  = this.dynamicValidationJson?.ADDRESS2?.required
      ? "*"
      : "";
      this.fieldCourtesyCardId = this.dynamicValidationJson?.COURTESY_CARD_ID?.required
      ? "*" : "";
   
   
      this.isCityRequired = this.dynamicValidationJson?.CITY?.required
       ? "*"
       : "";
   
       this.isZipRequired = this.dynamicValidationJson?.ZIP?.required
       ? "*"
       : "";
   
       this.isStateRequired = this.dynamicValidationJson?.STATE?.required
       ? "Select a State*"
       : "Select a  State";
      this.isPhoneRequired =  this.dynamicValidationJson?.PHONE_NUMBER?.required; 
            
  }
  openModal() {
    window.scroll(0,0);
  }

  onReset() {
    this.submitted = false;
    this.cloudPOSForms.reset({terminalType:this.ppdOrCcdOptionsArray.length == 1 ? get(this.ppdOrCcdOptionsArray,'[0].name',"") : null});
    this.clearFormErrors(this.cloudPOSForms)
    this.refillForm();
    this.isTokenTx = false;
    this.isMaskedCard = false;
    this.maskedRoutingFormat = "";
    this.maskedAccountFormat = "";
}

refillForm() {
  if (this.cloudPOSForms && this.dynamicValidationJson) {
    this.createPayaAchForm(false);
    this.cloudPOSForms.patchValue({
      usersId: this.usersID,
      terminalId: this.terminalId,
      identity: this.dynamicValidationJson?.IDENTITY?.required
    });
  }
}

clearFormErrors(formGroup: UntypedFormGroup) {
  Object.keys(formGroup.controls).forEach(controlName => {
    const control = formGroup.get(controlName);
    if (control instanceof UntypedFormGroup) {
      this.clearFormErrors(control);
    } else {
      // Clear errors for the control
      
      const validators = formGroup.get(controlName).validator;
      control.setErrors(null);
      formGroup.get(controlName).setValidators(validators)
      formGroup.get(controlName).updateValueAndValidity();
  
    }
  });
}


cleanValue(value: any): any {
  return value === null || value === "null" || value === "" ? "" : value;
}

  async onTransaction(isUpdate = false) {
    if(this.isTokenTx){
      let routingNumControllerTx = this.cloudPOSForms.get('routingNumber');
      let accountNumControllerTx = this.cloudPOSForms.get('accountNumber');
      routingNumControllerTx.setValidators([Validators.required, Validators.minLength(9), Validators.pattern(/^[0-9*]+$/)]);
      accountNumControllerTx.setValidators([ Validators.minLength(4), Validators.maxLength(17)]);
      accountNumControllerTx.updateValueAndValidity();
      routingNumControllerTx.updateValueAndValidity();
    }
    if (this.cloudPOSForms.get('state').value == 'Select a state') {
      this.cloudPOSForms.get('state').setErrors({ 'required': true });
    }
    if (this.cloudPOSForms.get('dlState').value == 'Select DL State' && this.dynamicValidationJson?.DL_STATE?.required) {
      this.cloudPOSForms.get('dlState').setErrors({ 'required': true });
    } else if (this.cloudPOSForms.get('dlState').value == 'Select DL State') {
      this.cloudPOSForms.value.dlState = '';
    }
    console.log(this.cloudPOSForms)

    let paymentInfo = this.parentCloudposForm.controls.paymentInfo;
    let amount = paymentInfo.controls.amt.value;
    let email = paymentInfo.controls.email.value;
    let phone = paymentInfo.controls.phone.value
    const isPhoneValid = paymentInfo.controls.phone.valid;



    if (this.isPhoneRequired && (!isPhoneValid || isEmpty(phone))) {
      this.phoneErrorHandler.emit({ required: true });
      return

    }
    this.cloudPOSForms.value.entryClass = this.isTelSecCode ? this.cloudPOSForms.value.entryClass : this.cloudPOSForms.value.terminalType;
    if (!this.cloudPOSForms.valid || (!amount || (this.isPhoneRequired && !isPhoneValid))) {
      this.submitted = true;
      return;
    }
   
    this.submitted = false;
   
    this.cloudPOSForms.get('amt').patchValue(this.prepareAmtFormat(amount, true));
    this.cloudPOSForms.get('email').patchValue(email);
    phone && this.cloudPOSForms.get('phone').patchValue(phone?.e164Number);
    let payaResponse;
    this.cloudPOSForms.value.entryClass = this.isTelSecCode ? this.cloudPOSForms.value.entryClass : this.cloudPOSForms.value.terminalType;
    if(this.isTokenTx){
      this.cloudPOSForms.value.isTokenTx = true;
      this.cloudPOSForms.value.payaId = this.payaId;
    }
    if(!isUpdate){
      if (email || phone) {
        this.payaAchFormData.emit({ showPaymentModal: this.isAddAch ? false : true });
      }
      if (!this.isAddAch) {
        await this.getExstingPayload(this.cloudPOSForms.get('accountNumber').value);
        return;
      }
    }else{
        this.cloudPOSForms.value.routingNumber =  this.cleanValue(this.updatedPayload.routingNumber);
        this.cloudPOSForms.value.accountNumber =  this.cleanValue(this.updatedPayload.accountNumber);
        this.cloudPOSForms.value.accountType =  this.cleanValue(this.updatedPayload.accountType);
        this.cloudPOSForms.value.firstName =  this.cleanValue(this.updatedPayload.firstName);
        this.cloudPOSForms.value.lastName =  this.cleanValue(this.updatedPayload.lastName);
        this.cloudPOSForms.value.city =  this.cleanValue(this.updatedPayload.city);
        this.cloudPOSForms.value.state =  this.cleanValue(this.updatedPayload.state);
        this.cloudPOSForms.value.zipCode =  this.cleanValue(this.updatedPayload.zipCode);
        this.cloudPOSForms.value.addressOne =  this.cleanValue(this.updatedPayload.addressOne);
        this.cloudPOSForms.value.addressTwo =  this.cleanValue(this.updatedPayload.addressTwo);
        this.cloudPOSForms.value.phone =  this.cleanValue(this.updatedPayload.phone);
        this.cloudPOSForms.value.dlState =  this.cleanValue(this.updatedPayload.dlState);
        this.cloudPOSForms.value.dlNumber =  this.cleanValue(this.updatedPayload.dlNumber);
        this.cloudPOSForms.value.companyName =  this.cleanValue(this.updatedPayload.companyName);
        this.cloudPOSForms.value.ssn =  this.cleanValue(this.updatedPayload.ssn);
        this.cloudPOSForms.value.birthYear =  this.cleanValue(this.updatedPayload.birthYear);
        this.cloudPOSForms.value.courtesyCardId =  this.cleanValue(this.updatedPayload.courtesyCardId);
        this.cloudPOSForms.value.isExstingPayloadUpdate =  this.isExstingPayloadUpdate;
    }

    this.cloudPOSForms.value.isFortellisEnabled =  this.isFortellisEnabled;
    this.cloudPOSForms.value.fortInvoice =  this.fortInvoice;
    this.cloudPOSForms.value.txTime =  moment().utc().format("HH:mm:ss");
    this.cloudPOSForms.value.txDate =  moment().utc().format("YYYY-MM-DD HH:mm:ss");
    
    let { formattedDateTime: posRequestDate, formattedTime: posRequestTime } = this.commonService.getFormattedDateTime();
    this.cloudPOSForms.value.posRequestDate =  posRequestDate;
    this.cloudPOSForms.value.posRequestTime =  posRequestTime;
    this.cloudPOSForms.value.hostResponseDate =  moment().utc().format("YYYY-MM-DD HH:mm:ss");
    this.cloudPOSForms.value.hostResponseTime =  moment().utc().format("HH:mm:ss");
    

    if (this.isAddAch || this.isAddBank) {  
      
      if(this.isAddBank){
        if(isEmpty(this.cleanValue(this.cloudPOSForms.value.phone))){
          this.cloudPOSForms.value.phone = this.cleanValue(phone);
        }
       this.addBankConfirmation.emit(this.cloudPOSForms.value);
       return 
      } else { 
      if(isEmpty(this.cleanValue(this.cloudPOSForms.value.phone)) && this.cleanValue(this.activatedRoute.snapshot?.params?.phone)){
        this.cloudPOSForms.value.phone = this.cleanValue(this.activatedRoute.snapshot?.params?.phone);
      }
      if(isEmpty(this.cleanValue(this.cloudPOSForms.value.email) && this.cleanValue(this.activatedRoute.snapshot?.params?.email)) ){
        this.cloudPOSForms.value.email = this.cleanValue(this.activatedRoute.snapshot?.params?.email);
      }

      window.scroll(0, 0);
      let ngbModalOptions: NgbModalOptions = {
        backdrop: 'static',
        keyboard: false,
        centered: true,
        size: 'lg',
      };
      this.modalRef = this.ngbModal.open(PaymentStatusComponent, ngbModalOptions);
      this.modalRef.componentInstance.isLoading = true;
      this.modalRef.result.then(result => {
        if (this.isAchAdded == 'true') {
          window.history.back();
        }
      });
        await this.commonService.postCommonHttpClient(`${apiLinks.PayaAch.addAch}/${this.activatedRoute.snapshot.paramMap.get('consumerId') || this.consumerId}`, { ...this.cloudPOSForms.value, isMerchantBilling: this.params?.isMerchantBilling == 'true' }).toPromise().then(res => {
        this.modalRef.componentInstance.isLoading = false;
        this.modalRef.componentInstance.isAchAdded = this.isAchAdded = 'true';
      }, err => {
        this.modalRef.componentInstance.isLoading = false;
        this.modalRef.componentInstance.isAchAdded = this.isAchAdded = 'false';
        this.modalRef.componentInstance.errorMessage = err.message;
      });
      return;
    }
  }

    if (!isEmpty(this.tagValues.tagLabel) && !isEmpty(this.tagValues.tagValue)) {
      this.cloudPOSForms.value.tagLabel = this.tagValues.tagLabel;
      this.cloudPOSForms.value.tagValue = this.tagValues.tagValue;
    }

    const identifier = this.parentCloudposForm?.controls?.identifier;
    if (this.transactionType === 3 ) {
      this.cloudPOSForms.value.identifier = identifier ? identifier?.value : '';
      this.cloudPOSForms.value.isFromTransaction = true;
    }

    if(this.isfromRunASale){
      let reqBody = {
        apiName: 'runASale',
        info: 'runASale at clousPOS',
        message: "performed run a sale",
        log_data: {
          ...this.cloudPOSForms.value,
          // consumerId: this.runAsSaleConsumerId
        }
      }
      this.commonService.postLog(reqBody);
    }

    await this.commonService.postCommonHttpClient(apiLinks.PayaAch.ProcessSingleCertificationCheckCloudPos, { ...this.cloudPOSForms.value, isMerchantBilling: this.params?.isMerchantBilling == 'true' }).toPromise().then(async res => {
      payaResponse = res;
      // prepare txalternate payload
      // if (hostPosResponseCode == "57") {
      //   alternatePaymentData.phoneNumber = "";
      //   alternatePaymentData.email = "";
      // }
      this.payaAchFormData.emit({ processAlternatePayment: true, alternatePayloadDetails: payaResponse?.signUpload?.txExtnPayload, payaResponse: payaResponse});
      // this.onReset();
      // this.notifyParentReset.emit()

    }, async err => {
      console.log('...err.......', err.status);
      // meaning validation error, before calling paya URLs
      if (get(err, 'status') == 412) {
        this.payaAchFormData.emit({ showPaymentModal: true, showError: true, err });
      } else if (get(err, 'status') == 406) {
        let emitData = {};
        // prepare txalternate payload
        // declined tx need transactionId
        // 
        // let status = get(err,'Response');
        // if(get(err,'Response')) {
        emitData = { showPaymentModal: true, showError: true, err };
        // } else if(get(err,'EXCEPTION')) {
        // emitData = {showPaymentModal:true, showError:true, err};
        // emitData = {processAlternatePayment:true, formData:{alternatePayloadDetails:this.cloudPOSForms.value,payaResponse}}
        // }
        // alternatePaymentData.phoneNumber = "";
        // alternatePaymentData.email = "";
        this.payaAchFormData.emit(emitData);
      } else {
        this.payaAchFormData.emit({ showPaymentModal: true, showError: true, err });

      }
      payaResponse = get(err, 'message.validationFailure');

    });
  }

  getPayaStates(){
    this.commonService.getCommonHttpClientParams(apiLinks.getPayaStates).subscribe(data => {
      this.payaStates = data;
    });
  }



  getExstingPayload(accountNumber) {
    this.getExstingCustomerPayload.emit(accountNumber);
  }

  ngOnDestroy() {
    // this.payaResponseValidationSubscription.unsubscribe();
    // this.payaResponseValuesSubsricption.unsubscribe();
    // this.formResetSubscription.unsubscribe();
    this.isPayaCheck.emit({isPaya:false})
    this.onReset()
    this.subscription.unsubscribe();
  }
  
  prepareAmtFormat(amount:string, isAlternatePayment:boolean) {
    if(isAlternatePayment) {
      return amount.length == 1 ? `0${amount}0` : amount.length == 2 ? `0${amount}` : `${amount}`
    }
    return amount;
  }

  // Get consumer details when focus on the routing number
  getConsumersTokenDetail(){
      this.getConsumerDetail.emit();
  }

  // When type email
  verifyAndOpenExistingCardsInfo(type){
    if(!this.isMaskedCard){
      this.verifyExstingCard.emit(this.usersID);
    }
  }

  // Reset paya details
  resetMaskedAlternateFormData() {
    this.createPayaAchForm();
  }

 // disable paya details
  isDisableResetData(){
    this.isDisableReset.emit();
    return this.isResetDisabled;
  }
  isTokenRemoved: boolean = false ;
  // Clear tokenized card details
  clearUnMaskedAlternateCardInfo(){
    let routingNumControllerTx = this.cloudPOSForms.get('routingNumber');
    let accountNumControllerTx = this.cloudPOSForms.get('accountNumber');
    if(routingNumControllerTx){
      routingNumControllerTx.setValidators([Validators.minLength(9), Validators.pattern(/^[0-9]+$/)]);
      routingNumControllerTx.updateValueAndValidity();
    }
    if(accountNumControllerTx){
      accountNumControllerTx.setValue('');  // Set an initial value if necessary


      accountNumControllerTx.setValidators([ Validators.minLength(4), Validators.maxLength(17)]);
      accountNumControllerTx.updateValueAndValidity();
    }
    this.isTokenTx = false;
    this.payaId = '';
    this.cardsLength = 0;
    this.isMaskedCard = false;
    this.maskedRoutingFormat = "";
    this.maskedAccountFormat = "";
    this.isTokenRemoved = true;
    this.clearUnMaskedAlternateCard.emit();
    this.resetMaskedAlternateFormData();
  }
  
}

